<div *ngFor="let paymentMethod of paymentMethods$ | async; let i = index">
  <app-radio-button-card
    [control]="control"
    [name]="name"
    [value]="paymentMethod.id"
    [ariaLabel]="
      paymentMethod.type === PaymentMethodType.CreditCard ? paymentMethod.info.number : paymentMethod.info.accountNumber
    "
    [isSelected]="!!(paymentMethod.id === control.value)"
    [handleSelect]="changeSelectedPaymentMethod.bind(this, paymentMethod.id)"
    [disabled]="isPaymentMethodExpired(paymentMethod) || false"
  >
    <div slot="header">
      <div
        *ngIf="
          paymentMethod.isDefault ||
          (paymentMethod.type === PaymentMethodType.CreditCard && paymentMethod.info.isHealthAccount)
        "
        class="flex flex-wrap mb-3 mt-0 md:-mt-2 xl:hidden"
        data-cy="payment-method-tag-container-mobile"
      >
        <p-tag
          *ngIf="paymentMethod.isDefault"
          styleClass="p-tag-purple p-tag-sm mr-2"
          value="Default"
          data-cy="default-payment-method-tag-mobile"
        >
        </p-tag>
        <p-tag
          *ngIf="paymentMethod.type === PaymentMethodType.CreditCard && paymentMethod.info.isHealthAccount"
          styleClass="p-tag-purple p-tag-sm"
          value="HSA"
          data-cy="hsa-credit-card-tag-mobile"
        >
        </p-tag>
      </div>
    </div>
    <div class="flex flex-column w-full md:ml-4">
      <div class="flex xl:-mt-1">
        <app-payment-method-details [paymentMethod]="paymentMethod"></app-payment-method-details>
        <div class="hidden xl:flex flex-wrap xl:ml-4 xl:flex-grow-0" data-cy="payment-method-tag-container-desktop">
          <p-tag
            *ngIf="paymentMethod.isDefault"
            styleClass="p-tag-purple p-tag-sm mr-2"
            value="Default"
            data-cy="default-payment-method-tag-mobile"
          >
          </p-tag>
          <p-tag
            *ngIf="paymentMethod.type === PaymentMethodType.CreditCard && paymentMethod.info.isHealthAccount"
            styleClass="p-tag-purple p-tag-sm"
            value="HSA"
            data-cy="hsa-credit-card-tag-mobile"
          >
          </p-tag>
        </div>
      </div>
      <div *ngIf="!!(paymentMethod.id === control.value)" class="mt-4">
        <p-checkbox
          label="Default payment method"
          [ngModel]="paymentMethod.id === (defaultPaymentMethod$ | async)?.id"
          [binary]="true"
          [trueValue]="true"
          [falseValue]="false"
          [disabled]="paymentMethod.id === (defaultPaymentMethod$ | async)?.id"
          styleClass="p-checkbox-sm"
          ariaLabel="Default payment method"
          (onChange)="changeDefaultPaymentMethod($event, paymentMethod.id)"
        ></p-checkbox>
      </div>
    </div>
  </app-radio-button-card>
</div>
